const auditFilterSchema = register => {
    return {
        after: () => register(),
        before: () => register(),
        entityType: () => register(),
    };
};

export default auditFilterSchema;
